import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = { class: "demo-tabs" }

import { ref, onMounted, watch } from "vue";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import { FollowUpStatus } from "@/services/datatype/business/service/FollowUpStatus";
import { PageBlockAccessSpec } from "@/services/datatype/paging/PageBlockAccessSpec";
import { EnterpriseFollowUpRecord } from "@/services/datatype/business/service/EnterpriseFollowUpRecord";
import Padding from "@/components/Layout/paging.vue";
import { DateFormat, FORMAT_TYPE } from "@/services/util/DateFormat";

export default /*#__PURE__*/_defineComponent({
  __name: 'Interview',
  setup(__props) {

const active = ref("0");
const tableData = ref([]);
const newData = ref([]);
const currentId = ref("");
const input = ref("");
const dialogVisible = ref(false);
//获取内容
const getDataOne = (data) => {
  newData.value = data;
};
async function handleConfirm() {
  dialogVisible.value = false;
  const enterpriseFollowUpRecord = new EnterpriseFollowUpRecord();
  enterpriseFollowUpRecord.enterpriseId = currentId.value;
  enterpriseFollowUpRecord.record = input.value;
  await DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseFollowUpManagementService()
    .recordEnterpriseFollow(enterpriseFollowUpRecord);
  const pageBlockAccessSpec = new PageBlockAccessSpec();
  const data = await DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseFollowUpManagementService()
    .getEnterpriseFollow(FollowUpStatus.NOT_FOLLOWED_UP, pageBlockAccessSpec);
  tableData.value = data.getPageData();
}

function confirm(row: EnterpriseFollowUpRecord) {
  currentId.value = row.enterpriseId;
  dialogVisible.value = true;
}

watch(active, (val) => {
  const pageBlockAccessSpec = new PageBlockAccessSpec();
  (async () => {
    const data = await DefaultWebServiceFactory.getInstance()
      .getWebEnterpriseFollowUpManagementService()
      .getEnterpriseFollow(
        active.value == "0"
          ? FollowUpStatus.NOT_FOLLOWED_UP
          : FollowUpStatus.FOLLOWED_UP,
        pageBlockAccessSpec
      );
    tableData.value = data.getPageData();
  })();
});
onMounted(async () => {
  const pageBlockAccessSpec = new PageBlockAccessSpec();
  const data = await DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseFollowUpManagementService()
    .getEnterpriseFollow(FollowUpStatus.NOT_FOLLOWED_UP, pageBlockAccessSpec);
  tableData.value = data.getPageData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      title: "是否确定回访?",
      width: "500"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: input.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
          placeholder: "请输入备注"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tabs, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((active).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "待回访",
            name: "0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                data: newData.value,
                border: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "企业名称"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "phone",
                    label: "手机号"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "createTime",
                    label: "创建时间"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.applyTime
                ? _unref(DateFormat).dateFormatString(
                    Number(scope.row.applyTime),
                    _unref(FORMAT_TYPE).NORMAL3
                  )
                : "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "joinTime",
                    label: "加入时间"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.joinTime
                ? _unref(DateFormat).dateFormatString(
                    Number(scope.row.joinTime),
                    _unref(FORMAT_TYPE).NORMAL3
                  )
                : "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { label: "操作" }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: ($event: any) => (confirm(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("确定回访")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(Padding, {
                data: tableData.value,
                "page-size": 10,
                onGetData: getDataOne
              }, null, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "已回访",
            name: "1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                data: newData.value,
                border: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "企业名称",
                    width: "180"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "phone",
                    label: "手机号",
                    width: "180"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "createTime",
                    label: "创建时间",
                    width: "180"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.applyTime
                ? _unref(DateFormat).dateFormatString(
                    Number(scope.row.applyTime),
                    _unref(FORMAT_TYPE).NORMAL3
                  )
                : "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "joinTime",
                    label: "加入时间",
                    width: "180"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.joinTime
                ? _unref(DateFormat).dateFormatString(
                    Number(scope.row.joinTime),
                    _unref(FORMAT_TYPE).NORMAL3
                  )
                : "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "dockingTime",
                    label: "回访时间",
                    width: "180"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.dockingTime
                ? _unref(DateFormat).dateFormatString(
                    Number(scope.row.dockingTime),
                    _unref(FORMAT_TYPE).NORMAL3
                  )
                : "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "record",
                    label: "备注",
                    width: "180"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "content",
                    label: "回访内容"
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(Padding, {
                data: tableData.value,
                "page-size": 10,
                onGetData: getDataOne
              }, null, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})